export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5680.8f5d5da7.jpg";